// extracted by extract-css-chunks-webpack-plugin
module.exports = {"details-div":"footer__details-div","cart-btns":"footer__cart-btns"};